import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Avatar.theme = Avatar.theme || {}; // eslint-disable-next-line func-names

Avatar.theme.Zoom = function () {
  var selectors = {
    imageZoom: '[data-image-zoom]'
  };
  var attributes = {
    imageZoomTarget: 'data-image-zoom-target'
  };

  function Zoom(container) {
    this.container = container;
    this.cache = {};
    this.url = container.dataset.zoom;

    this._cacheSelectors();

    if (!this.cache.sourceImage) return;

    this._duplicateImage();
  }

  Zoom.prototype = _objectSpread(_objectSpread({}, Zoom.prototype), {}, {
    _cacheSelectors: function _cacheSelectors() {
      this.cache = {
        sourceImage: this.container.querySelector(selectors.imageZoom)
      };
    },
    _init: function _init() {
      var targetWidth = this.cache.targetImage.width;
      var targetHeight = this.cache.targetImage.height;

      if (this.cache.sourceImage === this.cache.targetImage) {
        this.sourceWidth = targetWidth;
        this.sourceHeight = targetHeight;
      } else {
        this.sourceWidth = this.cache.sourceImage.width;
        this.sourceHeight = this.cache.sourceImage.height;
      }

      this.xRatio = (this.cache.sourceImage.width - targetWidth) / this.sourceWidth;
      this.yRatio = (this.cache.sourceImage.height - targetHeight) / this.sourceHeight;
    },
    _start: function _start(evt) {
      this._init();

      this._move(evt);

      this.cache.sourceImage.style.opacity = 0;
    },
    _stop: function _stop() {
      this.cache.sourceImage.style.opacity = 1;
      this.cache.targetImage.style.opacity = 0;
    },
    _setTopLeftMaxValues: function _setTopLeftMaxValues(top, left) {
      return {
        left: Math.max(Math.min(left, this.sourceWidth), 0),
        top: Math.max(Math.min(top, this.sourceHeight), 0)
      };
    },
    _move: function _move(evt) {
      // eslint-disable-next-line max-len
      var left = evt.pageX - (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX);
      var top = evt.pageY - (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY);

      var position = this._setTopLeftMaxValues(top, left);

      top = position.top;
      left = position.left;
      this.cache.targetImage.style.left = "".concat(-(left * -this.xRatio), "px");
      this.cache.targetImage.style.top = "".concat(-(top * -this.yRatio), "px");
      this.cache.targetImage.style.opacity = 1;
    },
    _duplicateImage: function _duplicateImage() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var image;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this._loadImage().catch(function (error) {
                  console.warn('Error fetching image', error);
                });

              case 2:
                image = _context.sent;
                _this.cache.targetImage = image;
                image.style.width = "".concat(image.width, "px");
                image.style.height = "".concat(image.height, "px");
                image.style.position = 'absolute';
                image.style.maxWidth = 'none';
                image.style.maxHeight = 'none';
                image.style.opacity = 0;
                image.style.border = 'none';
                image.style.left = 0;
                image.style.top = 0;

                _this.container.appendChild(image);

                if (!(image.width < 600 || image.height < 600)) {
                  _context.next = 17;
                  break;
                }

                // eslint-disable-next-line max-len
                console.warn("Uploaded image is too small to zoom. Zoomable images need to be at least 600x600, current upload is ".concat(image.width, "x").concat(image.height, " - ").concat(image.src));
                return _context.abrupt("return");

              case 17:
                _this._init();

                _this._start = _this._start.bind(_this);
                _this._stop = _this._stop.bind(_this);
                _this._move = _this._move.bind(_this);

                _this.container.addEventListener('mouseenter', _this._start);

                _this.container.addEventListener('mouseleave', _this._stop);

                _this.container.addEventListener('mousemove', _this._move);

                _this.container.style.position = 'relative';
                _this.container.style.overflow = 'hidden';

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    _loadImage: function _loadImage() {
      var _this2 = this;

      // eslint-disable-next-line
      return new Promise(function (resolve, reject) {
        var image = new Image();
        image.setAttribute('role', 'presentation');
        image.setAttribute(attributes.imageZoomTarget, true);
        image.src = _this2.url;
        image.addEventListener('load', function () {
          return resolve(image);
        });
        image.addEventListener('error', function (error) {
          return reject(error);
        });
      });
    },
    unload: function unload() {
      var targetImage = this.container.querySelector("[".concat(attributes.imageZoomTarget, "]"));

      if (targetImage) {
        targetImage.remove();
      }

      this.container.removeEventListener('mouseenter', this._start);
      this.container.removeEventListener('mouseleave', this._stop);
      this.container.removeEventListener('mousemove', this._move);
    }
  });
  return Zoom;
}();